import { ApiRequest, RequestMethod } from "../../request";

export async function removeInjury(
  fighterId: string,
  fighterInjuryId: string,
): Promise<boolean> {
  const apiRequest = new ApiRequest();
  apiRequest.setMethod(RequestMethod.DELETE);
  apiRequest.setUrl(`/api/fighter/${fighterId}/injury/${fighterInjuryId}`);
  return (await apiRequest.send()).status === 200;
}
